import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { payrollEndpoints } from "@/features/payroll/api/endpoints";
import type { PayrollBatchDto } from "@/features/payroll/api/dto";

/**
 * Détail d'une paie (`GET /PayrollBatches/{id}`) : statut, lignes, débit prévu,
 * `canLaunch` / `simulationExpiresAt`, `disbursementReference`. 404 si hors
 * périmètre (sauf back-office).
 */
export const usePayrollBatch = (batchId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.PAYROLL_BATCH_DETAIL(batchId),
    queryFn: () =>
      fetchDataGet<PayrollBatchDto>({
        url: payrollEndpoints.payrollBatches.detail(batchId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(batchId),
  });
